export interface TADateFilter {
  start_date?: string;
  end_date?: string;
  interval_type: string;
}

interface HostDateFilterSelection {
  label?: string;
  type?: string;
  startDate?: string;
  endDate?: string;
}

const labelMap: Record<string, string> = {
  mtd: 'MTD',
  monthtodate: 'MTD',
  currentmonthtodate: 'MTD',
  qtd: 'QTD',
  quartertodate: 'QTD',
  currentquartertodate: 'QTD',
  ytd: 'YTD',
  yeartodate: 'YTD',
  currentyeartodate: 'YTD',
  priorday: 'prior_day',
  priorweek: 'prior_week',
  priormonth: 'prior_month',
};

export const getFilterBarStorage = (): any => {
  try {
    return JSON.parse(window.sessionStorage.getItem('filter-bar-storage') || '{}');
  } catch {
    return {};
  }
};

export const getSessionDateSelection = (): HostDateFilterSelection | undefined =>
  getFilterBarStorage()?.state?.calendar?.data?.SelectedFilters;

export const getHostDateSelection = (): HostDateFilterSelection | undefined => {
  try {
    const hostStore = JSON.parse(window.localStorage.getItem('hostStore') || '{}');
    return hostStore?.defaultDateQuickButton;
  } catch {
    return undefined;
  }
};

export const buildTADateFilter = (
  selection?: HostDateFilterSelection,
  calendarValues?: string[]
): TADateFilter => {
  const selectionType = (selection?.label ?? selection?.type ?? '')
    .toLowerCase()
    .replace(/[^a-z]/g, '');
  const intervalType = labelMap[selectionType] ?? 'custom';

  if (
    intervalType === 'prior_day' ||
    intervalType === 'prior_week' ||
    intervalType === 'prior_month'
  ) {
    const referenceDate = new Date(selection?.endDate || new Date());
    const endDate = referenceDate.toISOString();
    const startDate = new Date(referenceDate);

    if (intervalType === 'prior_day') startDate.setDate(referenceDate.getDate() - 1);
    if (intervalType === 'prior_week') startDate.setDate(referenceDate.getDate() - 7);
    if (intervalType === 'prior_month') startDate.setMonth(referenceDate.getMonth() - 1);

    return {
      start_date: startDate.toISOString(),
      end_date: endDate,
      interval_type: 'custom',
    };
  }

  if (intervalType === 'custom') {
    return {
      start_date: selection?.startDate || calendarValues?.[0],
      end_date: selection?.endDate || calendarValues?.[1],
      interval_type: intervalType,
    };
  }

  return { interval_type: intervalType };
};

export const isSameTADateFilter = (
  current: TADateFilter | undefined,
  next: TADateFilter
): boolean => {
  return (
    current?.interval_type === next.interval_type &&
    current?.start_date === next.start_date &&
    current?.end_date === next.end_date
  );
};
